import { API_BASE_URL } from 'src/globals';

import { GET } from 'src/api/apiHandler';
import { FETCH_SHARED_DATA } from 'src/api/routes';

export const fetchSharedData = async (sharingId) => {
  return GET(`${API_BASE_URL}${FETCH_SHARED_DATA}/${sharingId}`);
};
